module.exports = __webpack_public_path__ + "img/sms-orange.cdbaf4ce.svg";